import { CatalogVariantFragmentFragment } from '@notino/shared/definitions/types';

import { useResolvedVoucherDiscount } from '../VoucherDiscount/useResolvedVoucherDiscount';
import { isConditionalDiscount } from '../VoucherDiscount/utils';

export const useIsMinPriceDisplayedInVoucher = (
  variant: CatalogVariantFragmentFragment
) => {
  const voucher = useResolvedVoucherDiscount(variant);

  const isSimpleVoucher = voucher && !isConditionalDiscount(voucher);
  const isSingleConditionVoucher =
    voucher &&
    isConditionalDiscount(voucher) &&
    voucher.discountConditions.length === 1;

  return (
    variant.recentMinPrice &&
    (isSimpleVoucher ||
      (isSingleConditionVoucher && voucher.discountType === 'Percentage'))
  );
};
